module.exports = __webpack_public_path__ + "img/ticket-pattern-1.4d868d17.svg";